"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PowerPlant = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Tags_1 = require("../Tags");
var Units_1 = require("../../Units");
var PowerPlant = (function (_super) {
    __extends(PowerPlant, _super);
    function PowerPlant() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.POWER_PLANT_PATHFINDERS,
            cost: 13,
            tags: [Tags_1.Tags.MARS, Tags_1.Tags.ENERGY, Tags_1.Tags.BUILDING],
            productionBox: Units_1.Units.of({ heat: 2, energy: 1 }),
            metadata: {
                cardNumber: 'Pf20',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production((function (pb) { return pb.heat(2).energy(1); }));
                }),
                description: 'Increase your heat production 2 steps and your energy production 1 step.',
            },
        }) || this;
    }
    PowerPlant.prototype.play = function (player) {
        player.adjustProduction(this.productionBox);
        return undefined;
    };
    return PowerPlant;
}(Card_1.Card));
exports.PowerPlant = PowerPlant;
